module.exports = __webpack_public_path__ + "img/honor-27001.9d81b8fb.png";